import { gql } from '@apollo/client'

export const RATE_CONNECTION_GENERATE_MUTATION = gql`
  mutation RateConnectionGenerate($input: RateConnectionGenerateInput!) {
    rateConnectionGenerate(input: $input) {
      trackingID
    }
  }
`

export const RATE_CONNECTION_LIST_QUERY = gql`
  query RateConnectionList($input: RateConnectionListFilters!) {
    rateConnectionList(input: $input) {
      roomTypes {
        name
        code
        id
        ratePlans {
          name
          code
          id
          channels {
            name
            code
            id
            priceClasses {
              name
              Id
              dataForEachDate {
                date
                isConnect
              }
            }
            rateMultipliers {
              name
              dataForEachDate {
                date
                rateMultiplierValue
              }
            }
          }
        }
      }
    }
  }
`

export const RATE_CONNECTION_UPDATE_MUTATION = gql`
  mutation RateConnectionUpdate($input: [RateConnectionUpdateInput!]!) {
    rateConnectionUpdate(input: $input) {
      trackingID
    }
  }
`
